import {Component, EventEmitter, OnInit, Output, input, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';

import {Survey, SurveyRequest} from '@app/api/models/survey';
import {WaDateInputDirective, WaInputDirective} from "angular-awesome";

@Component({
    selector: 'app-survey-properties',
    templateUrl: './survey-properties.component.html',
    styleUrls: ['./survey-properties.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, WaInputDirective, WaDateInputDirective]
})
export class SurveyPropertiesComponent implements OnInit {

  readonly survey = input<Survey | null>(null);
  @Output() inputEvent = new EventEmitter<SurveyRequest | null>();

  surveyProperties = new FormGroup({
    name: new FormControl<string | null>(null, [Validators.required]),
    begin: new FormControl<string | Date | null>(null, [Validators.required]),
    end: new FormControl<string | Date | null>(null, [Validators.required])
  });

  constructor() {}

  ngOnInit(): void {
    this.surveyProperties.valueChanges.subscribe(() => {
      this.propagateInput();
    });

    const survey = this.survey();
    if (!survey) {
      // Set default voting period: today to today + 7 days
      const today = new Date();
      const nextWeek = new Date();
      nextWeek.setDate(today.getDate() + 7);
      this.surveyProperties.controls['begin'].setValue(this.formatDateForInput(today));
      this.surveyProperties.controls['end'].setValue(this.formatDateForInput(nextWeek));
      return;
    }

    this.surveyProperties.controls['name'].setValue(survey.name);
    this.surveyProperties.controls['begin'].setValue(survey.begin);
    this.surveyProperties.controls['end'].setValue(survey.end);
  }

  private formatDateForInput(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

private propagateInput(): void {
  if (!this.surveyProperties.valid) {
    this.inputEvent.emit(null);
    return;
  }

  // Send as ISO date strings (YYYY-MM-DD), not Date objects
  const beginStr = typeof this.begin === 'string'
    ? this.begin
    : this.formatDateForInput(this.begin!);
  const endStr = typeof this.end === 'string'
    ? this.end
    : this.formatDateForInput(this.end!);

  this.inputEvent.emit({
    name: this.name!,
    begin: beginStr,  // "2026-01-24"
    end: endStr       // "2026-01-31"
  });
}



  get name() { return this.surveyProperties.value.name || null }
  get begin() { return this.surveyProperties.value.begin || null }
  get end() { return this.surveyProperties.value.end || null }
}
